import { DateTimeControl } from "./DateTimeControl";

/**
 * DateTime Control which does not convert date to the correct timezone.
 */
export class DateTimeNoTimeZoneControl extends DateTimeControl {
    
    /**
     * @hidden
     */
    protected dmsControlClass: string = "dms-control-datetime-no-timezone";

    /**
     * @hidden
     */
    protected bindingProperty = "customDateNoTimeZone";

    /**
     * Gets the display template for formatting in grid row.
     * @hidden
     */
    protected getDisplayTemplate(bindingField?: string): string {
        return `#= ${bindingField} == null ? "${this.controlDefinition.ReplaceNullValue ||
            ""}"  : DMS.Util.formatDateTimeNoTimeZone(new Date(${bindingField})) # `;
    }
}
